// extracted by mini-css-extract-plugin
export default {"container":"GDTTemplateRulesPage_container__fBSXl","field":"GDTTemplateRulesPage_field__8fm9x","table":"GDTTemplateRulesPage_table__Q1ZW3"};